module.exports = __webpack_public_path__ + "static/img/IMG_20151222_170509.8486f2be.jpg";